import React from 'react';
import ReactDOM from 'react-dom';
import { ReverbUITheme, ThemeProvider } from '@reverb-ui/react';
import { Router } from './router/Router';
import AppRouter from './router/AppRouter';
import { Shell } from './container/Shell';
import { AuthContextProvider } from 'contexts/auth'
import {getSSOClient} from "./main/singleton/sso-client";
import { Userpilot } from "userpilot"

Userpilot.initialize("38jo76j9")
Userpilot.anonymous()

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={ReverbUITheme} resetCSS>
      <AuthContextProvider ssoClient={getSSOClient()}>
        <Router>
          <Shell>
            <AppRouter />
          </Shell>
        </Router>
      </AuthContextProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
